import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

import { PreventDragDropDirective } from '../common/drag-and-drop/prevent-dragdrop.directive';
import { SpinnerComponent } from '../common/spinner/spinner.component';
import { ZiggeoPlayerConfig } from './ziggeo-player-config';

@Component({
  selector: 'rt-ziggeo-player',
  templateUrl: './ziggeo-player.component.html',
  styleUrls: ['./ziggeo-player.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, PreventDragDropDirective, SpinnerComponent],
})
export class ZiggeoPlayerComponent {
  @Input() public token: string;
  @Input() public noAnswer: string = this.i18nService.translate('rtu.questionnaires.no_answer');

  public posterLoadingFailed: boolean = false;
  public playing: boolean = false;
  public canPlay: boolean = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private ziggeoPlayerConfig: ZiggeoPlayerConfig,
    private i18nService: I18nService,
  ) {}

  public get videoUrl(): string {
    return this.getZigeoResourceURL('video');
  }

  public get posterUrl(): string {
    return this.getZigeoResourceURL('image');
  }

  public play(): void {
    this.playing = true;
    this.cdRef.detectChanges();
  }

  public onCanPlay(): void {
    this.canPlay = true;
    this.cdRef.detectChanges();
  }

  public onPosterLoadError(): void {
    this.posterLoadingFailed = true;
    this.cdRef.detectChanges();
  }

  private getZigeoResourceURL(resourceKind: 'video' | 'image'): string {
    return `https://embed-cdn-eu-west-1.ziggeo.com/v1/applications/${this.ziggeoPlayerConfig.ziggeoToken}/videos/${this.token}/${resourceKind}`;
  }
}
